import { Paper, Text, Group, Button } from '@mantine/core'
import { IconPencil } from '@tabler/icons-react'
import { SignatureModal } from '../SignatureModal'
import { todayFormatted } from './formHelpers'

type Props = {
  signatureDataUrl: string
  signatureDate: string
  savedSignature: string | null
  signatureModalOpen: boolean
  onOpenModal: () => void
  onCloseModal: () => void
  onConfirm: (dataUrl: string, date: string) => void
  onSaveSignature: (dataUrl: string) => Promise<void>
  certificationText?: string
  /** Defaults to the orders wording; letters are not ordered by anyone. */
  heading?: string
}

export const SignatureSection = ({
  signatureDataUrl,
  signatureDate,
  savedSignature,
  signatureModalOpen,
  onOpenModal,
  onCloseModal,
  onConfirm,
  onSaveSignature,
  certificationText,
  heading = 'ORDERING PROVIDER SIGNATURE',
}: Props) => (
  <Paper p="md" withBorder>
    <Text fw={600} size="lg" mb="sm" className="text-[#6B21A8]">
      {heading}
    </Text>
    {certificationText && (
      <Text size="xs" c="dimmed" mb="sm">
        {certificationText}
      </Text>
    )}

    {signatureDataUrl ? (
      <div>
        <div className="mb-2 inline-block rounded-md border border-gray-200 bg-white p-2">
          <img
            src={signatureDataUrl}
            alt="Provider signature"
            style={{ height: 60, width: 'auto' }}
          />
        </div>
        <Group gap="sm">
          <Text size="sm" c="dimmed">
            Signed on {signatureDate}
          </Text>
          <Button
            variant="subtle"
            size="xs"
            leftSection={<IconPencil size={14} />}
            onClick={onOpenModal}
          >
            Re-sign
          </Button>
        </Group>
      </div>
    ) : (
      <Group gap="sm" align="flex-end">
        {savedSignature && (
          <>
            <div className="inline-block rounded-md border border-blue-200 bg-blue-50 p-2">
              <img
                src={savedSignature}
                alt="Saved signature"
                style={{ height: 40, width: 'auto' }}
              />
            </div>
            <Button
              variant="light"
              size="sm"
              onClick={() => onConfirm(savedSignature, todayFormatted())}
            >
              Use Saved Signature
            </Button>
            <Text size="xs" c="dimmed">
              or
            </Text>
          </>
        )}
        <Button variant="outline" leftSection={<IconPencil size={16} />} onClick={onOpenModal}>
          Sign
        </Button>
      </Group>
    )}

    <SignatureModal
      opened={signatureModalOpen}
      onClose={onCloseModal}
      onConfirm={onConfirm}
      savedSignatureDataUrl={savedSignature}
      onSaveSignature={onSaveSignature}
    />
  </Paper>
)
